const login = {
  path: '',
  component: resolve => require(['../../../../pages/home/user/login'], resolve)
}

export default login
